import { ClientPortfolios, Portfolio, PortfolioCategory } from './portfolio-considerations.types';

export const clientPortfolioConsiderations: Portfolio[] = [
	{
		id: 1186432,
		symbol: 'P:1186432',
		name: 'Concurrent Balanced Model Portfolio',
		category: PortfolioCategory.MODERATE,
		linkUrl: '/portfolio/1186432',
		linkText: 'View Portfolio Details',
	},
	{
		id: 1214096,
		symbol: 'P:1214096',
		name: 'Concurrent Equity Income Balanced Strategy EINB',
		category: PortfolioCategory.MODERATE,
		linkUrl: '/portfolio/1214096',
		linkText: 'View Portfolio Details',
	},
	{
		id: 1241060,
		symbol: 'P:1241060',
		name: 'Concurrent Responsible ESG - Conservative',
		category: PortfolioCategory.MODERATE,
		linkUrl: '/portfolio/1241060',
		linkText: 'View Portfolio Details',
	},
	{
		id: 1126432,
		symbol: 'P:1186432',
		name: 'Concurrent Balanced Model Portfolio',
		category: PortfolioCategory.MODERATE,
		linkUrl: '/portfolio/1126432',
		linkText: 'View Portfolio Details',
	},
	{
		id: 1215096,
		symbol: 'P:1214096',
		name: 'Concurrent Equity Income Balanced Strategy EINB',
		category: PortfolioCategory.MODERATE,
		linkUrl: '/portfolio/1215096',
		linkText: 'View Portfolio Details',
	},
	{
		id: 1241000,
		symbol: 'P:1241060',
		name: 'Concurrent Responsible ESG - Conservative',
		category: PortfolioCategory.MODERATE,
		linkUrl: '/portfolio/1241000',
		linkText: 'View Portfolio Details',
	},
	{
		id: 3186432,
		symbol: 'P:1186432',
		name: 'Concurrent Balanced Model Portfolio',
		category: PortfolioCategory.MODERATE,
		linkUrl: '/portfolio/3186432',
		linkText: 'View Portfolio Details',
	},
	{
		id: 1714096,
		symbol: 'P:1214096',
		name: 'Concurrent Equity Income Balanced Strategy EINB',
		category: PortfolioCategory.MODERATE,
		linkUrl: '/portfolio/1714096',
		linkText: 'View Portfolio Details',
	},
	{
		id: 1211060,
		symbol: 'P:1241060',
		name: 'Concurrent Responsible ESG - Conservative',
		category: PortfolioCategory.MODERATE,
		linkUrl: '/portfolio/1211060',
		linkText: 'View Portfolio Details',
	},
	{
		id: 1986432,
		symbol: 'P:1186432',
		name: 'Concurrent Balanced Model Portfolio',
		category: PortfolioCategory.MODERATE,
		linkUrl: '/portfolio/1986432',
		linkText: 'View Portfolio Details',
	},
	{
		id: 1234096,
		symbol: 'P:1214096',
		name: 'Concurrent Equity Income Balanced Strategy EINB',
		category: PortfolioCategory.MODERATE,
		linkUrl: '/portfolio/1234096',
		linkText: 'View Portfolio Details',
	},
	{
		id: 1141160,
		symbol: 'P:1241060',
		name: 'Concurrent Responsible ESG - Conservative',
		category: PortfolioCategory.MODERATE,
		linkUrl: '/portfolio/1141160',
		linkText: 'View Portfolio Details',
	},
];

export const portfolioConsiderations: ClientPortfolios = {
	clientId: 12345,
	portfoliosRecommendation: [
		{
			id: 1186432,
			symbol: 'P:1186432',
			name: 'Concurrent Balanced Model Portfolio',
			category: PortfolioCategory.MODERATE,
			clientSelected: true,
			linkUrl: '/portfolio/1186432',
			linkText: 'View Portfolio Details',
		},
		{
			id: 1214096,
			symbol: 'P:1214096',
			name: 'Concurrent Equity Income Balanced Strategy EINB',
			category: PortfolioCategory.MODERATE,
			clientSelected: false,
			linkUrl: '/portfolio/1214096',
			linkText: 'View Portfolio Details',
		},
		{
			id: 1241060,
			symbol: 'P:1241060',
			name: 'Concurrent Responsible ESG - Conservative',
			category: PortfolioCategory.MODERATE,
			clientSelected: true,
			linkUrl: '/portfolio/1241060',
			linkText: 'View Portfolio Details',
		},
	],
};
